import { getSecondsIntervalMs } from "../../datafeed/secondsHistory";
import { SECONDS_FIRST_VIEW_MS, SECONDS_FIRST_VIEW_RIGHT_OFFSET_BARS } from "../constants";

/**
 * 15S / 30S: the first time a
 * seconds timeframe is opened in this chart, the zoom shows the last
 * 15 minutes. Later the zoom is left alone: going back to seconds or
 * switching 15S ↔ 30S keeps it, as on minute timeframes.
 */
export const createSecondsFirstView = () => {
  let isApplied = false;

  return {
    /**
     * @param {object} timeScale - its width must already be known
     * @param {string|null} resolution
     */
    apply: (timeScale, resolution) => {
      const intervalMs = getSecondsIntervalMs(resolution);

      if (isApplied || !intervalMs || timeScale.width <= 0) return;

      isApplied = true;

      const visibleBarCount = SECONDS_FIRST_VIEW_MS / intervalMs;

      timeScale.setView({
        barSpacing: timeScale.width / (visibleBarCount + SECONDS_FIRST_VIEW_RIGHT_OFFSET_BARS),
        rightOffset: SECONDS_FIRST_VIEW_RIGHT_OFFSET_BARS,
      });
    },
  };
};
